export default __webpack_public_path__ + "static/media/default.c84593c0.jpg";